import React from "react";
import { Sun, Moon, Monitor } from "lucide-react";
import { useTheme } from "../lib/theme";

const OPTS = [["light", Sun, "Light"], ["dark", Moon, "Dark"], ["system", Monitor, "System"]];

export function ThemeToggle({ compact = false, testid = "theme-toggle" }) {
  const { pref, setPref } = useTheme();
  return (
    <div className={`theme-toggle ${compact ? "compact" : ""}`} role="radiogroup" aria-label="Theme" data-testid={testid}>
      {OPTS.map(([id, Icon, label]) => (
        <button key={id} type="button" className={pref === id ? "active" : ""} onClick={() => setPref(id)} title={label} aria-checked={pref === id} role="radio" data-testid={`${testid}-${id}`}>
          <Icon size={12} />{!compact && <span>{label}</span>}
        </button>
      ))}
    </div>
  );
}
